import {lazy} from 'react';
import type {RouteObject} from 'react-router-dom';

const Login = lazy(() => import('@/pages/mngt/Login'));
const ResetPassword = lazy(() => import('@/pages/mngt/ResetPassword'));

const loginRoutes: RouteObject[] = [
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/login/reset-password',
    element: <ResetPassword />
  }
];

export default loginRoutes;
